import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { handleError } from './user';
import { setuserinfo } from './nurseshift';
import dateFormat from 'dateformat';
import { downloadFile as dlFile } from '../utils/downloadFile';

export const setAccountErrors = createAction('SET_ACCOUNT_ERRORS');
export const setAccountDisplay = createAction('SET_ACCOUNT_DISPLAY');
export const setAccountMessage = createAction('SET_ACCOUNT_MESSAGE');
export const setAccountFirstName = createAction('SET_ACCOUNT_FIRST_NAME');
export const setAccountLastName = createAction('SET_ACCOUNT_LAST_NAME');
export const setAccountAddres = createAction('SET_ACCOUNT_ADDRESS');
export const setAccountCity = createAction('SET_ACCOUNT_CITY');
export const setAccountState = createAction('SET_ACCOUNT_STATE');
export const setAccountZipcode = createAction('SET_ACCOUNT_ZIPCODE');
export const setAccountPrimaryPhone = createAction('SET_ACCOUNT_PRIMARY_PHONE');
export const setAccountAlternatePhone = createAction('SET_ACCOUNT_ALTERNATE_PHONE');
export const setProfileFileID = createAction('SET_PROFILE_FILE_ID');
export const setProfilePreview = createAction('SET_PROFILE_PREVIEW');

export const setReviewUnderProcessRedirPath = createAction('SET_REVIEW_UNDER_PROCESS_REDIR_PATH');
export const setIncompletedRedirPath = createAction('SET_INCOMPLETED_REDIR_PATH');
export const setAccoountAccessDenied = createAction('SET_ACCOUNT_ACCESS_DENIED');
export const setBackBtnClicked = createAction('SET_BACK_BTN_CLICKED');

export const setAccountOldPassword = createAction('SET_ACCOUNT_OLD_PASSWORD');
export const setAccountNewPassword = createAction('SET_ACCOUNT_NEW_PASSWORD');
export const setAccountConfirmPassword = createAction('SET_ACCOUNT_CONFIRM_PASSWORD');
export const clearProfilepic = createAction('CLEAR_USERPROFILEPIC');

export const resetAccount = createAction('REST_ACCOUNT');

export const setUserPreferences = createAction('SET_USER_PREFERENCES');
export const setDownloadingFile = createAction('SET_DOWNLOADING_FILE');

const initialState = {
	accessDenied: false,
	address: '',
	alternatePhoneNumber: '',
	backBtnClicked: true,
	city: '',
	confirmPassword: '',
	display: 'none',
	errors: {},
	firstName: '',
	incompletedRedirPath: '/nurse/onboarding-contact-info',
	isDownloadingFile: false,
	lastName: '',
	message: '',

	newPassword: '',
	oldPassword: '',
	primaryPhoneNumber: '',
	profileImageFileID: '',

	profileImagePreview: '',
	reviewUnderProcessRedirPath: '/nurse/registration/complete',
	state: '',

	userNotiPreferences: {},
	zipcode: ''
};

export default handleActions(
	{
		CLEAR_USERPROFILEPIC: (state) => ({
			...state,
			profileImagePreview: initialState.profileImagePreview
		}),
		REST_ACCOUNT: () => initialState,
		SET_ACCOUNT_ACCESS_DENIED: (state, action) => ({ ...state, accessDenied: action.payload }),
		SET_ACCOUNT_ADDRESS: (state, action) => ({ ...state, address: action.payload }),
		SET_ACCOUNT_ALTERNATE_PHONE: (state, action) => ({
			...state,
			alternatePhoneNumber: action.payload
		}),
		SET_ACCOUNT_CITY: (state, action) => ({ ...state, city: action.payload }),
		SET_ACCOUNT_CONFIRM_PASSWORD: (state, action) => ({
			...state,
			confirmPassword: action.payload
		}),
		SET_ACCOUNT_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_ACCOUNT_FIRST_NAME: (state, action) => ({ ...state, firstName: action.payload }),
		SET_ACCOUNT_LAST_NAME: (state, action) => ({ ...state, lastName: action.payload }),
		SET_ACCOUNT_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_ACCOUNT_NEW_PASSWORD: (state, action) => ({ ...state, newPassword: action.payload }),
		SET_ACCOUNT_OLD_PASSWORD: (state, action) => ({ ...state, oldPassword: action.payload }),

		SET_ACCOUNT_PRIMARY_PHONE: (state, action) => ({
			...state,
			primaryPhoneNumber: action.payload
		}),
		SET_ACCOUNT_STATE: (state, action) => ({ ...state, state: action.payload }),
		SET_ACCOUNT_ZIPCODE: (state, action) => ({ ...state, zipcode: action.payload }),
		SET_BACK_BTN_CLICKED: (state, action) => ({ ...state, backBtnClicked: action.payload }),

		SET_DOWNLOADING_FILE: (state, action) => ({ ...state, isDownloadingFile: action.payload }),
		SET_INCOMPLETED_REDIR_PATH: (state, action) => ({
			...state,
			incompletedRedirPath: action.payload
		}),
		SET_PROFILE_FILE_ID: (state, action) => ({ ...state, profileImageFileID: action.payload }),

		SET_PROFILE_PREVIEW: (state, action) => ({ ...state, profileImagePreview: action.payload }),

		SET_REVIEW_UNDER_PROCESS_REDIR_PATH: (state, action) => ({
			...state,
			reviewUnderProcessRedirPath: action.payload
		}),
		SET_USER_PREFERENCES: (state, action) => ({ ...state, userNotiPreferences: action.payload })
	},
	initialState
);

export const updateAccountContact = () => {
	return function (dispatch, getState) {
		const { firstName, lastName, address, city, state, zipcode, primaryPhoneNumber, alternatePhoneNumber } =
			getState().account;

		Agent.updateUserContact(
			firstName,
			lastName,
			address,
			city,
			state,
			zipcode,
			primaryPhoneNumber,
			alternatePhoneNumber
		).then((response) => {
			if (response.ok) {
				alert('Your personal information has been saved.');
			} else {
				alert("Couldn't save your personal information.");
			}
		});
	};
};

export const fetchAccountContact = () => {
	return function (dispatch) {
		let userInfoAry = [];
		Agent.userContact().then((response) => {
			if (response.ok) {
				userInfoAry = response.data;
				dispatch(updateinfo(userInfoAry));
				dispatch(setuserinfo(userInfoAry));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const updateinfo = (info) => {
	return function (dispatch) {
		dispatch(setAccountFirstName(info.first_name));
		dispatch(setAccountLastName(info.last_name));
		dispatch(setAccountAddres(info.address));
		dispatch(setAccountCity(info.city));
		dispatch(setAccountState(info.state));
		dispatch(setAccountZipcode(info.zip));
		dispatch(setAccountPrimaryPhone(info.phone));
		dispatch(setAccountAlternatePhone(info.alt_phone));
		dispatch(setProfilePreview(info.profile_photo));
	};
};

export const uploadProfileImage = (file, i) => {
	return function (dispatch) {
		if (file) {
			dispatch(setAccountDisplay('block'));
			Agent.uploadFileOnS3UserProfile(file, i).then((response) => {
				if (response.ok) {
					dispatch(setProfilePreview(response.data.path));
				} else {
					alert('Failed to upload user image. Please check you file type and file size.');
				}
				dispatch(setAccountDisplay('none'));
			});
		}
	};
};

export const getUserDefaultPreferences = () => {
	return function (dispatch) {
		Agent.getUserDefaultPreferences().then((response) => {
			if (response.ok) {
				let userNotiPreferences = response.data;

				let isSupervisor = userNotiPreferences.DeptLocPreference !== null;
				let isAdmin = userNotiPreferences.OrgPreference !== null;

				// Setting notifyme value as per user's preferences.
				let isAllSelected = true;
				let isAtLeastOneSelected = false;
				let prefs = userNotiPreferences.Preference;
				if (prefs && prefs.length > 0) {
					for (let pIdx = 0; pIdx < prefs.length; pIdx++) {
						for (let idx = 0; idx < prefs[pIdx].message_details.length; idx++) {
							let trans_id = prefs[pIdx].message_details[idx].transport_id;
							if (isAdmin) {
								if (trans_id != 1 && trans_id != 3 && trans_id != 4) {
									//Skip Mobile, SMS, InApp
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							} else if (isSupervisor) {
								if (trans_id != 1 && trans_id != 3) {
									//Skip Mobile, SMS,
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							} else {
								if (trans_id != 3) {
									//Skip SMS
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							}
						}
					}
				}
				userNotiPreferences.notifyme = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;

				// Adding one extra department to handle location row.
				let deptLocPrefs = userNotiPreferences.DeptLocPreference;
				if (deptLocPrefs && deptLocPrefs.length > 0) {
					for (let pIdx = 0; pIdx < deptLocPrefs.length; pIdx++) {
						let isAllSelected = true;
						let isAtLeastOneSelected = false;
						for (let idx = 0; idx < deptLocPrefs[pIdx].departments.length; idx++) {
							if (deptLocPrefs[pIdx].departments[idx].status === 0) {
								isAllSelected = false;
							} else {
								isAtLeastOneSelected = true;
							}
						}
						deptLocPrefs[pIdx].departments = [deptLocPrefs[pIdx].departments[0], ...deptLocPrefs[pIdx].departments];
						deptLocPrefs[pIdx].status = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;
					}
				}

				// Adding one extra location to handle organization row.
				let orgPrefs = userNotiPreferences.OrgPreference;
				if (orgPrefs && orgPrefs.length > 0) {
					for (let pIdx = 0; pIdx < orgPrefs.length; pIdx++) {
						let isAllSelected = true;
						let isAtLeastOneSelected = false;
						for (let idx = 0; idx < orgPrefs[pIdx].locations.length; idx++) {
							if (orgPrefs[pIdx].locations[idx].status === 0) {
								isAllSelected = false;
							} else {
								isAtLeastOneSelected = true;
							}
						}
						orgPrefs[pIdx].locations = [orgPrefs[pIdx].locations[0], ...orgPrefs[pIdx].locations];
						orgPrefs[pIdx].status = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;
						orgPrefs[pIdx].collapsed = true;
					}
				}

				dispatch(setUserPreferences(userNotiPreferences));
			}
		});
	};
};

export const getUserPreferences = () => {
	return function (dispatch) {
		Agent.getUserPreferences().then((response) => {
			if (response.ok) {
				let userNotiPreferences = response.data;

				let isSupervisor = userNotiPreferences.DeptLocPreference !== null;
				let isAdmin = userNotiPreferences.OrgPreference !== null;

				// Setting notifyme value as per user's preferences.
				let isAllSelected = true;
				let isAtLeastOneSelected = false;
				let prefs = userNotiPreferences.Preference;
				if (prefs && prefs.length > 0) {
					for (let pIdx = 0; pIdx < prefs.length; pIdx++) {
						for (let idx = 0; idx < prefs[pIdx].message_details.length; idx++) {
							let trans_id = prefs[pIdx].message_details[idx].transport_id;
							// (1, 'email'),
							// (2, 'pushnotice'),
							// (3, 'sms'),
							// (4, 'inapp')
							if (isAdmin) {
								if (trans_id != 2 && trans_id != 3 && trans_id != 4) {
									//Skip Mobile, SMS, InApp
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							} else if (isSupervisor) {
								if (trans_id != 2 && trans_id != 3) {
									//Skip Mobile, SMS,
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							} else {
								if (trans_id != 3) {
									//Skip SMS
									if (prefs[pIdx].message_details[idx].status === 0) {
										isAllSelected = false;
									} else {
										isAtLeastOneSelected = true;
									}
								}
							}
						}
					}
				}
				userNotiPreferences.notifyme = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;

				// Supervisor - Adding one extra department to handle location row.
				let deptLocPrefs = userNotiPreferences.DeptLocPreference;
				if (deptLocPrefs && deptLocPrefs.length > 0) {
					for (let pIdx = 0; pIdx < deptLocPrefs.length; pIdx++) {
						if (deptLocPrefs[pIdx].departments.length === 0) {
							deptLocPrefs.splice(pIdx, 1);
							pIdx -= 1;
						} else {
							let isAllSelected = true;
							let isAtLeastOneSelected = false;
							for (let idx = 0; idx < deptLocPrefs[pIdx].departments.length; idx++) {
								if (deptLocPrefs[pIdx].departments[idx].status === 0) {
									isAllSelected = false;
								} else {
									isAtLeastOneSelected = true;
								}
							}
							deptLocPrefs[pIdx].departments = [deptLocPrefs[pIdx].departments[0], ...deptLocPrefs[pIdx].departments];
							deptLocPrefs[pIdx].status = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;
						}
					}
				}

				// Admin - Adding one extra location to handle organization row.
				let orgPrefs = userNotiPreferences.OrgPreference;
				if (orgPrefs && orgPrefs.length > 0) {
					for (let pIdx = 0; pIdx < orgPrefs.length; pIdx++) {
						if (orgPrefs[pIdx].locations.length === 0) {
							orgPrefs.splice(pIdx, 1);
							pIdx -= 1;
						} else {
							let isAllSelected = true;
							let isAtLeastOneSelected = false;
							for (let idx = 0; idx < orgPrefs[pIdx].locations.length; idx++) {
								if (orgPrefs[pIdx].locations[idx].status === 0) {
									isAllSelected = false;
								} else {
									isAtLeastOneSelected = true;
								}
							}
							orgPrefs[pIdx].locations = [orgPrefs[pIdx].locations[0], ...orgPrefs[pIdx].locations];
							orgPrefs[pIdx].status = isAllSelected ? 1 : isAtLeastOneSelected ? 2 : 0;
							orgPrefs[pIdx].collapsed = true;
						}
					}
				}

				dispatch(setUserPreferences(userNotiPreferences));
			}
		});
	};
};

export const saveUserPreferences = (userPref) => {
	return function () {
		Agent.saveUserPreferences(userPref).then(() => {});
	};
};

// please do NOT use this constant
export const downloadCSV = (url, fileName) => {
	return function () {
		Agent.downloadCSV(url).then((response) => {
			const fn = `connectrn-${fileName}${dateFormat(new Date(), 'yyyy-mm-dd', false)}`;
			dlFile(response, fn);
		});
	};
};

// please do NOT use this constant
// instead please make the agent call in your individual file
export const downloadFile = (url, fileType) =>
	function (dispatch) {
		dispatch(setDownloadingFile(true));
		Agent.downloadCSV(url).then((response) => {
			const ft = fileType === 'pdf' ? 'application/pdf' : `image/${fileType}`;
			const fn = `connectrn-${dateFormat(new Date(), 'yyyy-mm-dd', false)}.${fileType}`;
			dlFile(response, fn, ft);
			dispatch(setDownloadingFile(false));
		});
	};
